import type { MosaicPhoto } from '@/shared/domain'
import { PhotoMosaic } from './photo-mosaic'

type PhotoDayGroupSectionProps = {
  label: string
  mosaicPhotos: MosaicPhoto[]
  globalIndexOffset: number
  onPhotoClick: (id: string, index: number) => void
  canEdit?: boolean
  onRemove?: (id: string) => Promise<void>
  onEdit?: (id: string) => void
}

function PhotoDayGroupSection({
  label,
  mosaicPhotos,
  globalIndexOffset,
  onPhotoClick,
  canEdit = false,
  onRemove,
  onEdit,
}: PhotoDayGroupSectionProps) {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-lg font-semibold">{label}</h3>
      <PhotoMosaic
        photos={mosaicPhotos}
        canEdit={canEdit}
        onRemove={onRemove}
        onEdit={onEdit}
        onPhotoClick={(id, localIndex) =>
          onPhotoClick(id, globalIndexOffset + localIndex)
        }
      />
    </div>
  )
}

export { PhotoDayGroupSection }
export type { PhotoDayGroupSectionProps }
